import { LogOut, UserRound } from 'lucide-react';
import { useTheme } from '../../context/ThemeContext';
import { useAuth } from '../../auth/AuthContext';

// Sidebar footer: the signed-in operator + a sign-out action. Sign-out clears the session and
// the RequireAuth guard then redirects to /login on the next render.

export function OperatorMenu() {
  const { theme } = useTheme();
  const isDark = theme === 'dark';
  const { operator, signOut } = useAuth();

  if (!operator) return null;

  return (
    <div className="flex items-center gap-3">
      <span className="flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-xl bg-gradient-to-br from-indigo-500 to-purple-600 text-white shadow-lg shadow-indigo-500/20">
        <UserRound className="h-5 w-5" aria-hidden="true" />
      </span>
      <div className="min-w-0 flex-1">
        <p
          className={`truncate text-sm font-medium ${
            isDark ? 'text-white' : 'text-slate-900'
          }`}
        >
          {operator.email}
        </p>
        <p
          className={`text-[11px] uppercase tracking-widest ${
            isDark ? 'text-white/40' : 'text-slate-400'
          }`}
        >
          {operator.role}
        </p>
      </div>
      <button
        type="button"
        onClick={signOut}
        aria-label="Sign out"
        className={`flex h-9 w-9 flex-shrink-0 items-center justify-center rounded-lg transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-indigo-500/40 ${
          isDark
            ? 'text-white/40 hover:bg-white/[0.06] hover:text-white'
            : 'text-slate-400 hover:bg-slate-100 hover:text-slate-600'
        }`}
      >
        <LogOut className="h-4 w-4" aria-hidden="true" />
      </button>
    </div>
  );
}
